<template>
    <div style="height: 100%;">
        <router-view></router-view>
        <vue-progress-bar></vue-progress-bar>
        <notifications position="top center" class="fizmix-notification" :width="400"/>
        <reveal></reveal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {}
        },

        computed: {
            ...mapGetters(['user', 'isAuthenticated']),
        },

        watch: {
            user: function (val) {
                console.log("Authenticated", val);
                if (val !== null && val.newsletter === null) {
                    // Require newsletter update
                    this.$modal.openReveal(require('./components/auth/NewsletterReveal.vue'));
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/App.vue